<template>
  <div class="form-login">
    <h3>HUB</h3>
    <div class="input-group">
      <div class="input-group-btn">
        <button class="btn btn-primary" disabled><i class="glyphicon glyphicon-user"></i></button>
      </div>
      <input ref="iptlogin" type="text" v-model="usuario" class="form-control" placeholder="Login">
    </div>
    <div class="input-group">
      <div class="input-group-btn">
        <button class="btn btn-primary" disabled><i class="glyphicon glyphicon-lock"></i></button>
      </div>
      <input @keyup.enter="login()" type="password" v-model="senha" class="form-control" placeholder="Senha">
    </div>
    <button @click.prevent="login()" class="btn btn-primary">Entrar</button>
  </div>
</template>

<script>
import swal from 'sweetalert'
export default {
  name: '',
  data () {
    return {
      usuario: '',
      senha: ''
    }
  },
  methods: {
    load (params = '') {
      const url = './api/php/getuser.php'
      this.$http.post(url, JSON.stringify(params)).then(
        function (response) {
          console.log(response)
          const login = response.body.login
          if (login.status) {
            this.$root.auth = true
            this.$root.cod = login.cod
            this.$root.nome = login.nome
            this.$root.nivel = login.nivel
            this.$router.push({path: '/home'})
          } else {
            this.usuario = ''
            this.senha = ''
            swal('Ops...', login.msg, 'error')
          }
        },
        function (error) {
          console.log(error)
        }
      )
    },
    login () {
      if (this.login === '' || this.senha === '') {
        swal('Campos Obrigatórios', 'Favor informar login e senhas para acesso', 'error')
      } else {
        this.load({'login': this.usuario, 'pass': this.senha})
      }
    }
  },
  created: function () {
    if (this.$root.auth) {
      this.$router.push({path: '/home'})
    } else {
      this.$nextTick(() => { this.$refs.iptlogin.focus() })
    }
  }
}
</script>

<style scoped>
  .form-login {
    width: 20vw;
    margin: 30vh auto 30vh auto;
    background: #e1e1e1;
    padding: 20px;
    border-radius: 0px 50px;
    min-width: 300px;
  }
  .form-login .input-group {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue